import { render, staticRenderFns } from "./flag-it.vue?vue&type=template&id=1f1f1564"
import script from "./flag-it.vue?vue&type=script&lang=js"
export * from "./flag-it.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports